var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { useFieldArray } from 'react-final-form-arrays';
import { FormErrorText } from '@/components/ui/Form/FormErrorText';
import { FIELD_ERROR_DOM_CLASS_NAME } from '@/utils/form/scroll';
/**
 * ArrayField のエラーテキスト表示
 * NOTE: 配列内の Field のエラーがある場合は表示しない想定（表示する場合は改修してください）
 * @param props
 * @returns
 */
export const FieldsErrorText = (props) => {
    const { name } = props, errorTextProps = __rest(props, ["name"]);
    const { meta: { error, submitError, touched }, } = useFieldArray(name, {
        subscription: { error: true, submitError: true, touched: true },
    });
    const arrayFieldError = useMemo(() => {
        const errorMessage = error || submitError;
        return typeof errorMessage === 'string' ? errorMessage : undefined;
    }, [error, submitError]);
    return touched && arrayFieldError ? (_jsx(FormErrorText, Object.assign({}, errorTextProps, { className: clsx(FIELD_ERROR_DOM_CLASS_NAME, errorTextProps.className) }, { children: error || submitError }))) : null;
};
